type UserInfoLike = {
  uid?: number;
  level?: string;
  plan?: {
    name?: string;
  };
  aliasCount?: number;
  limits?: {
    aliasLimits?: number;
  };
};

export type AliasUpgradeTier = 'a' | 'b' | 'c' | null;

export function getEffectivePlanName(userInfo?: UserInfoLike | null) {
  return userInfo?.plan?.name || userInfo?.level || 'free';
}

export function isLimitedFreePlan(userInfo?: UserInfoLike | null) {
  const planName = getEffectivePlanName(userInfo);
  const aliasLimit = userInfo?.limits?.aliasLimits;
  return planName === 'free' && typeof aliasLimit === 'number' && aliasLimit >= 0;
}

export function isAliasLimitReached(userInfo: UserInfoLike | null | undefined, aliasCount: number) {
  if (!isLimitedFreePlan(userInfo)) return false;
  const aliasLimit = userInfo?.limits?.aliasLimits ?? -1;
  return aliasCount >= aliasLimit;
}

export function getAliasUpgradeTier(userInfo?: UserInfoLike | null): AliasUpgradeTier {
  if (!isLimitedFreePlan(userInfo)) return null;
  const aliasCount = userInfo?.aliasCount || 0;

  if (aliasCount > 100) return 'a';
  if (aliasCount >= 21) return 'b';
  if (aliasCount >= 6) return 'c';
  if (isAliasLimitReached(userInfo, aliasCount)) return 'c';
  return null;
}
